import { useEffect } from 'react'

import { Outlet, ScrollRestoration } from 'react-router'
import { Toaster } from 'sonner'

export function RootLayout() {
  const mql = globalThis.matchMedia('(display-mode: standalone)')
  useEffect(() => {
    if (mql.matches) {
      document.title = ''
    }
  }, [mql.matches])

  return (
    <>
      <Outlet />
      <Toaster position="top-right" />
      <ScrollRestoration />
    </>
  )
}
